import { requireElement } from "./Hud";

export type MinigameMenuChoice = "play" | "records" | "back";

export interface MinigameMenuOptions {
  title: string;
}

/**
 * Menu de entrada de um minigame: jogar ou ver os recordes daquele jogo. Cada
 * minigame carrega seu proprio placar aqui, entao nao existe mais uma placa
 * central na cidade.
 */
export function showMinigameMenu(options: MinigameMenuOptions): Promise<MinigameMenuChoice> {
  return new Promise((resolve) => {
    const root = requireElement<HTMLDivElement>("overlay-root");
    const overlay = document.createElement("div");
    overlay.className = "overlay";
    overlay.innerHTML = `
      <div class="panel">
        <h1 class="brand">${escapeHtml(options.title)}</h1>
        <p class="sub">O que você quer fazer?</p>
        <button type="button" class="primary" id="mm-play">Jogar</button>
        <button type="button" class="secondary" id="mm-records">Recordes</button>
        <button type="button" class="secondary" id="mm-back">Voltar para a cidade</button>
      </div>
    `;
    root.replaceChildren(overlay);

    const finish = (choice: MinigameMenuChoice) => {
      document.removeEventListener("keydown", onKey);
      root.replaceChildren();
      resolve(choice);
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        finish("back");
      }
    };
    document.addEventListener("keydown", onKey);

    overlay.querySelector<HTMLButtonElement>("#mm-play")!.addEventListener("click", () => finish("play"));
    overlay.querySelector<HTMLButtonElement>("#mm-records")!.addEventListener("click", () => finish("records"));
    overlay.querySelector<HTMLButtonElement>("#mm-back")!.addEventListener("click", () => finish("back"));
  });
}

function escapeHtml(value: string): string {
  const div = document.createElement("div");
  div.textContent = value;
  return div.innerHTML;
}
